import { defineComponent as _defineComponent } from 'vue'
import { feeDirectionLabels, feeReasonLabels } from 'ah-api-gateways';
import { FeeEntry } from 'ah-trades/../ah-api-gateways/models';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeeReason',
  props: {
    fee: null
  },
  setup(__props: any) {

const props = __props as {
  fee: FeeEntry;
};



const feeReasonText = computed(() => feeReasonLabels[props.fee.reason] + ' ' + feeDirectionLabels[props.fee.direction]);

return { __sfc: true,props, feeReasonText }
}

})